import { connect } from 'react-redux';
import CertificateFaq from '../components/CertificateFaq';
import { FAQ_ITEMS } from '../store/certificate/constants';

const mapStateToProps = () => ({
  items: FAQ_ITEMS,
});

export default connect(mapStateToProps)(CertificateFaq);
